import React from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { CardContainer, LightButton } from "best-common-react";
import AdditionalOptions from "./AdditionalOptions";
import { CompConstants } from "../../constants/CompConstants";
import { ReportConstants } from "../../constants/ReportConstants";
import TimeFrames from "./TimeFrames";

class RankingsComp extends React.Component {
  render() {
    let { compStore, trackingHelper } = this.props.rootStore;
    return (
      <React.Fragment>
        <CardContainer>
          <CardContainer.Body>
            <div className="container-fluid">
              <div className="row mx-0">
                <TimeFrames tab={CompConstants.TABS.RANKINGS} />
                <AdditionalOptions tab={CompConstants.TABS.RANKINGS} />
              </div>
            </div>
          </CardContainer.Body>
          <CardContainer.Footer>
            <div className="header-item-row">
              <LightButton
                onClick={() => {
                  if ("selStat" !== compStore.comp.reportCriteria.selectedForSummary) {
                    compStore.comp.rankbystatId = compStore.comp.reportCriteria.selectedForSummary;
                  }

                  trackingHelper.trackClickAndRunComp(ReportConstants.REPORT_DETAILEDRANK, "Run Rank Report Click");
                }}
              >
                Run Rank Report
              </LightButton>
            </div>
          </CardContainer.Footer>
        </CardContainer>
      </React.Fragment>
    );
  }
}

RankingsComp.propTypes = {
  rootStore: PropTypes.object.isRequired
};

export default inject("rootStore")(observer(RankingsComp));
